import { Trans } from '@lingui/react'

import Button from 'views/components/atoms/Button'
import { LOGIN_MODAL_ID } from 'views/consts/names'

const LoginButton = () => {
  return (
    <>
      <p>
        <Trans id="cart.order.login.redpoints" />
      </p>
      <Button
        name={LOGIN_MODAL_ID}
        style="buttonGhost"
        data-a11y-dialog-show={LOGIN_MODAL_ID}
        isClientsideControlled
      >
        <Trans id="general.link.label.login" />
      </Button>
    </>
  )
}

export default LoginButton
